import CategoryView from "./CategoryView";


const CatalogCategoriesView = (props) => {
	const { categories, userDomain } = props;

	if (!categories) {
		return null;
	};

	const keys = Object.keys(categories).sort();
	return (
		<div className="container-fluid">
			<div className="row">
				{keys?.map((category, index) => (
					<div key={index} className="d-flex flex-column mb-3">
						<CategoryView
							category={category}
							bots={categories[category]}
							userDomain={userDomain}
						/>
					</div>
				))}
			</div>
		</div>
	);
};

export default CatalogCategoriesView;
